import React, { useState } from 'react';
import { PropertyCard } from './PropertyCard';
import { PropertyListView } from './PropertyListView';
import { PropertyFilters } from './PropertyFilters';
import { ViewToggle } from './ViewToggle';
import { Property } from '../../types/property';
import { Building2 } from 'lucide-react';

interface PropertyCategoryViewProps {
  title: string;
  properties: Property[];
  isLoading?: boolean;
}

export const PropertyCategoryView: React.FC<PropertyCategoryViewProps> = ({
  title,
  properties,
  isLoading = false,
}) => {
  const [view, setView] = useState<'grid' | 'list'>('grid');

  return (
    <div>
      {title && (
        <div className="mb-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Building2 className="h-8 w-8 text-primary-500" />
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
              {title}
            </h1>
          </div>
          <div className="flex items-center gap-4">
            <ViewToggle view={view} onViewChange={setView} />
            <PropertyFilters />
          </div>
        </div>
      )}
      
      {!title && (
        <div className="mb-6 flex items-center justify-end">
        <div className="flex items-center gap-4">
          <ViewToggle view={view} onViewChange={setView} />
          <PropertyFilters />
        </div>
        </div>
      )}

      {isLoading ? (
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {[...Array(4)].map((_, i) => (
            <div
              key={i}
              className="h-[200px] animate-pulse rounded-lg bg-gray-200 dark:bg-gray-700"
            />
          ))}
        </div>
      ) : properties.length === 0 ? (
        <div className="rounded-lg border-2 border-dashed border-gray-300 p-8 text-center dark:border-gray-700">
          <Building2 className="mx-auto h-12 w-12 text-gray-400" />
          <h3 className="mt-2 text-sm font-medium text-gray-900 dark:text-white">
            Aucun bien disponible
          </h3>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Les biens que vous ajouterez apparaîtront ici
          </p>
        </div>
      ) : view === 'grid' ? (
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {properties.map((property) => (
            <PropertyCard key={property.id} property={property} />
          ))}
        </div>
      ) : (
        <PropertyListView properties={properties} />
      )}
    </div>
  );
};